import { LeaveDurationNames } from "../../../types/common-types";

interface LeaveDayCardProps {
  day: number;
  code: string;
  type: LeaveDurationNames;
  variant?: "leave" | "absent";
}

const LeaveDayCard: React.FC<LeaveDayCardProps> = ({
  day,
  code,
  type,
  variant = "leave",
}) => {
  const isAbsent = variant === "absent";

  return (
    <div className="flex w-[70px] shrink-0 flex-col items-center justify-center gap-1 bg-gray-100 px-2 py-2 text-center">
      <span className="text-xs font-medium leading-4 text-gray-900">
        {day}
      </span>

      {isAbsent ? (
        <span className="flex h-5 w-5 items-center justify-center rounded-full border border-danger text-xs font-medium leading-none text-danger">
          {code}
        </span>
      ) : (
        <span
          className={`text-xs font-medium leading-4 text-danger`}
        >
          {code}
        </span>
      )}

      <span className="text-[12px] leading-3 text-grayText">
        {type}
      </span>
    </div>
  );
};

export default LeaveDayCard;